export const SITE_STATUS_DRAFT_ID = 1
export const SITE_STATUS_PROPOSED_ID = 2
export const SITE_STATUS_NOMINATED_ID = 3
export const SITE_STATUS_REVIEWED_BY_RFP_ID = 4
export const SITE_STATUS_CONFIRMED_ID = 5
export const SITE_STATUS_SUPERSEDED_ID = 6
export const SITE_STATUS_DELISTED_ID = 7
export const SITE_STATUS_DOES_NOT_QUALIFY = 8
export const SITE_STATUS_EDIT_ONLY_ID = 9
export const SITE_STATUS_SUBMITTED_EDIT_ONLY_ID = 10
export const SITE_STATUS_NOT_ASSESSED_ID = 11

const siteStatuses = [
  { id: SITE_STATUS_DRAFT_ID, name: 'Draft' },
  { id: SITE_STATUS_PROPOSED_ID, name: 'Proposed' },
  { id: SITE_STATUS_NOMINATED_ID, name: 'Nominated' },
  { id: SITE_STATUS_REVIEWED_BY_RFP_ID, name: 'Reviewed by RFP' },
  { id: SITE_STATUS_CONFIRMED_ID, name: 'Confirmed' },
  { id: SITE_STATUS_SUPERSEDED_ID, name: 'Superseded' },
  { id: SITE_STATUS_DELISTED_ID, name: 'Delisted' },
  { id: SITE_STATUS_DOES_NOT_QUALIFY, name: 'Does not Qualify' },
  { id: SITE_STATUS_EDIT_ONLY_ID, name: 'Edit Only' },
  { id: SITE_STATUS_SUBMITTED_EDIT_ONLY_ID, name: 'Submitted Edits' },
  { id: SITE_STATUS_NOT_ASSESSED_ID, name: 'Not assessed' }
]

export default siteStatuses
